<div class="spinner-container" *ngIf="showSpinner">
  <div class="spinner-wrapper">
    <div class="spinner-border spinner text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
  </div>
</div>
